import { call, put, takeLatest } from "redux-saga/effects";
import * as api from "../constants/api";
import {
  GET_SLACK_BOT_SELECT,
  SG_GET_SLACK_BOT_SELECT,
  SG_GET_SLACK_SCHEDULER,
  GET_SLACK_SCHEDULER,
  SG_FETCH_SLACK_SCHEDULER,
  FETCH_SLACK_SCHEDULER,
  SG_ADD_SLACK_SCHEDULER,
  ADD_SLACK_SCHEDULER,
  SG_EDIT_SLACK_SCHEDULER,
  EDIT_SLACK_SCHEDULER,
  SG_DELETE_SLACK_SCHEDULER,
  DELETE_SLACK_SCHEDULER,
  PENDING_SLACK_SCHEDULER,
  GET_SLACK_SCHEDULER_SEARCH_EMPLOYEES,
  SG_GET_SLACK_SCHEDULER_SEARCH_EMPLOYEES,
  GET_SLACK_SCHEDULER_ADD_EMPLOYEES,
  SG_GET_SLACK_SCHEDULER_ADD_EMPLOYEES,
  GET_SLACK_SCHEDULER_REMOVE_EMPLOYEES,
  SG_GET_SLACK_SCHEDULER_REMOVE_EMPLOYEES,
  ALL_ERRORS,
} from "../constants/actions";

function* getSlackSBotSelect(action) {
  try {
    const response = yield call(api.GET_SLACK_BOT_SELECT, action.payload);
    yield put({ type: GET_SLACK_BOT_SELECT, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* getSlackScheduler(action) {
  try {
    yield put({ type: PENDING_SLACK_SCHEDULER });
    const response = yield call(api.GET_SLACK_SCHEDULER, action.payload);
    yield put({ type: GET_SLACK_SCHEDULER, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* fetchSlackScheduler(action) {
  try {
    yield put({ type: PENDING_SLACK_SCHEDULER });
    const response = yield call(api.FETCH_SLACK_SCHEDULER, action.payload);

    yield put({ type: FETCH_SLACK_SCHEDULER, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}
function* addSlackScheduler(action) {
  try {
    yield put({ type: PENDING_SLACK_SCHEDULER });
    const response = yield call(api.ADD_SLACK_SCHEDULER, action.payload);
    yield put({ type: ADD_SLACK_SCHEDULER, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* editSlackScheduler(action) {
  try {
    yield put({ type: PENDING_SLACK_SCHEDULER });
    const response = yield call(api.EDIT_SLACK_SCHEDULER, action.payload);
    yield put({ type: EDIT_SLACK_SCHEDULER, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* deleteSlackScheduler(action) {
  try {
    yield put({ type: PENDING_SLACK_SCHEDULER });
    const response = yield call(api.DELETE_SLACK_SCHEDULER, action.payload);
    yield put({ type: DELETE_SLACK_SCHEDULER, payload: response.data });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* searchEmployees(action) {
  try {
    yield put({ type: PENDING_SLACK_SCHEDULER });
    const response = yield call(
      api.GET_SLACK_SCHEDULER_SEARCH_EMPLOYEES,
      action.payload
    );
    yield put({
      type: GET_SLACK_SCHEDULER_SEARCH_EMPLOYEES,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* addEmployees(action) {
  try {
    yield put({ type: PENDING_SLACK_SCHEDULER });
    const response = yield call(
      api.GET_SLACK_SCHEDULER_ADD_EMPLOYEES,
      action.payload
    );
    yield put({
      type: GET_SLACK_SCHEDULER_ADD_EMPLOYEES,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}

function* deleteEmployees(action) {
  try {
    yield put({ type: PENDING_SLACK_SCHEDULER });
    const response = yield call(
      api.GET_SLACK_SCHEDULER_REMOVE_EMPLOYEES,
      action.payload
    );
    yield put({
      type: GET_SLACK_SCHEDULER_REMOVE_EMPLOYEES,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: ALL_ERRORS, payload: error.response });
  }
}
export default function* slackSchedulerSaga() {
  yield takeLatest(SG_GET_SLACK_BOT_SELECT, getSlackSBotSelect);
  yield takeLatest(SG_GET_SLACK_SCHEDULER, getSlackScheduler);
  yield takeLatest(SG_FETCH_SLACK_SCHEDULER, fetchSlackScheduler);
  yield takeLatest(SG_ADD_SLACK_SCHEDULER, addSlackScheduler);
  yield takeLatest(SG_EDIT_SLACK_SCHEDULER, editSlackScheduler);
  yield takeLatest(SG_DELETE_SLACK_SCHEDULER, deleteSlackScheduler);
  yield takeLatest(SG_GET_SLACK_SCHEDULER_SEARCH_EMPLOYEES, searchEmployees);
  yield takeLatest(SG_GET_SLACK_SCHEDULER_ADD_EMPLOYEES, addEmployees);
  yield takeLatest(SG_GET_SLACK_SCHEDULER_REMOVE_EMPLOYEES, deleteEmployees);
}
